<template>
  <div class="contentArea_inner inner">
    <div class="descriptionArea inner">
      <p>
        <span>VimeoLiveしているホールに対してアンケートの表示を行います。</span>
        <br />
        <span>対象のホール名の下にあるアンケートIDごとのボタンを押下することで対象のホールに任意アンケートが表示されます。</span>
      </p>

      <h3>
        <span>アンケートの表示</span>
      </h3>

      <div class="buttonArea side" v-for="hall in halls" :key="hall.id">
        <p>{{ hall.name }}</p>
        <button
          v-for="setting in getAnyEventSettings(hall)"
          :key="setting.questionnaire_id"
          type="button"
          class="btn"
          @click="showPerQuestionnaire(hall.slug, setting.questionnaire_id)"
        >
          アンケートID: {{ setting.questionnaire_id }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {LiveQuestionnaire} from "socket_if"
import SettingType from "../../../../common/js/enum/questionnaire-setings/type"

export default {
  name: "QuestionnaireManagement",
  computed: {
    halls() {
      return this.$store.getters["hall/getLiveHalls"]
    }
  },
  methods: {
    showPerQuestionnaire(slug, questionnaireId, isHall = true) {
      this.$socket.dispatcher.emitLiveQuestionnaire(
        new LiveQuestionnaire({
          slug: slug,
          questionnaireId: questionnaireId,
          isHall: isHall
        })
      )
    },
    getAnyEventSettings(hall) {
      return _.filter(hall.questionnaire_settings, {type: SettingType.ANY.value})
    }
  }
}
</script>
